import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { UJE_PAYMENT_DOCUMENT } from "./apiRoutes";

interface mutateProps {
  communityId: string;
  data: FieldValues
}

const mutateParkPayment = async ({ data, communityId }: mutateProps) => {
  return await axiosAuth.post(`${UJE_PAYMENT_DOCUMENT(communityId)}/submit`, data);
};

const useParkPaymentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateParkPayment,
    ...queryParams,
  });

export default useParkPaymentMutation;
